const provinceActionTypes = {
    GET_PROVINCE_LIST_SUCCESS: "GET_PROVINCE_LIST_SUCCESS",
    GET_PROVINCE_LIST_ERROR: "GET_PROVINCE_LIST_ERROR",
  };
  
  export default provinceActionTypes;